export default __webpack_public_path__ + "ru.0593d003.svg";